//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as apiConst from '../service/api/api-const'
    export default{
        name:'christmas_form_eight',
        data(){
            return{
                n:0,
                m:0,
                host:apiConst.host,
                form:{
                    prove:[],
                    intermediate_nurse_sign:'',//中级护理师签字
                    senior_nurse:'',//护理长签字
                    in_record_date:'',//入会时间
                    out_record_date:'',//出会时间
                    in_family:'',//入会母亲家属签名
                    out_family:'',//出会母亲家属签名
                    infoot:[],//出会足印图片
                    outfoot:[],//入会足印图片
                    into_intermediate_nurse_sign:'',
                    into_senior_nurse:''
                },
                showSignature:false,
                showCSignature:false,
                showInMotherSignature:false,
                showOutMotherSignature:false,
                showIntoSignature:false,
                showCIntoSignature:false,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
            }
        },
        methods:{
            //入会中级护理师签名
            saveCIntoName(){
                let signature ='signature5'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.into_intermediate_nurse_sign = encodeURI(png)
                this.showCIntoSignature = true
            },
            editCIntoName(){
                this.showCIntoSignature = false
                this.form.into_intermediate_nurse_sign = ''
            },
            clearCIntoName(){
                let signature ='signature5'
                let refs = this.$refs[signature].clear()
                this.form.into_intermediate_nurse_sign = ''
            },
            //入会护理长签字
            saveIntoName(){
                let signature ='signature6'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.into_senior_nurse = encodeURI(png)
                this.showIntoSignature = true
            },
            editIntoName(){
                this.showIntoSignature = false
                 this.form.into_senior_nurse = ''
            },
            clearIntoName(){
                let signature ='signature6'
                let refs = this.$refs[signature].clear()
                this.form.into_senior_nurse = ''
            },
            //入会母亲签名
            saveInMotherName(){
                let signature ='signature3'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.in_family = encodeURI(png)
                this.showInMotherSignature = true
            },
            editInMotherName(){
                this.showInMotherSignature = false
                this.form.in_family = ''
            },
            clearInMotherName(){
                let signature ='signature3'
                let refs = this.$refs[signature].clear()
                this.form.in_family = ''
            },
            //出会母亲签名
            saveOutMotherName(){
                let signature ='signature4'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.out_family = encodeURI(png)
                this.showOutMotherSignature = true
            },
            editOutMotherName(){
                this.showOutMotherSignature = false
                this.form.out_family = ''
            },
            clearOutMotherName(){
                let signature ='signature4'
                let refs = this.$refs[signature].clear()
                this.form.out_family = ''
            },
            //出会中级护理师签名
            saveCName(){
                let signature ='signature1'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.intermediate_nurse_sign = encodeURI(png)
                this.showCSignature = true
            },
            editCName(){
                this.showCSignature = false
                this.form.intermediate_nurse_sign = ''
            },
            clearCName(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.intermediate_nurse_sign = ''
            },
            //出会护理长签字
            saveName(){
                let signature ='signature2'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.senior_nurse = encodeURI(png)
                this.showSignature = true
            },
            editName(){
                this.showSignature = false
                 this.form.senior_nurse = ''
            },
            clearName(){
                let signature ='signature2'
                let refs = this.$refs[signature].clear()
                this.form.senior_nurse = ''
            },
            
            //提交
            submitForm(){
               
                // if(this.form.infoot.length==0){
                //     this.$vux.toast.show({
                //             type: 'cancel',
                //             text: '至少上传一张入会所脚印的图片',
                //     })
                //     return
                // }
                // if(this.form.in_family==''){
                //     this.$vux.toast.show({
                //             type: 'cancel',
                //             text: '缺少入会所母亲或家属的签字',
                //     })
                //     return
                // }
                // if(this.form.in_record_date==''){
                //     this.$vux.toast.show({
                //             type: 'cancel',
                //             text: '入会所时间不能为空',
                //     })
                //     return
                // }
                // if(this.form.outfoot.length==0){
                //     this.$vux.toast.show({
                //             type: 'cancel',
                //             text: '至少上传一张出会所脚印的图片',
                //     })
                //     return
                // }
                // if(this.form.out_family==''){
                //     this.$vux.toast.show({
                //             type: 'cancel',
                //             text: '缺少出会所母亲或家属的签字',
                //     })
                //     return
                // }
                // if(this.form.out_record_date==''){
                //     this.$vux.toast.show({
                //             type: 'cancel',
                //             text: '出会所时间不能为空',
                //     })
                //     return
                // }
                // if(this.form.intermediate_nurse_sign==''){
                //     this.$vux.toast.show({
                //             type: 'cancel',
                //             text: '缺少中级护理师签字',

                //     })
                //     return
                // }
                // if(this.form.senior_nurse==''){
                //     this.$vux.toast.show({
                //             type: 'cancel',
                //             text: '缺少护理长签字',
                //     })
                //     return
                // }
                let params={
                    token:this.$cookie.get('token'),
                    member_id:this.$cookie.get('id'),
                    maternal_info_id:this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    baby_id:this.$route.query.child_id,
                    intermediate_nurse_sign:this.form.intermediate_nurse_sign,
                    senior_nurse:this.form.senior_nurse,
                    in_record_date:this.form.in_record_date,
                    out_record_date:this.form.out_record_date,
                    in_family:this.form.in_family,
                    out_family:this.form.out_family,
                    into_intermediate_nurse_sign:this.form.into_intermediate_nurse_sign,
                    into_senior_nurse:this.form.into_senior_nurse
                }
                let filesIn=this.form.infoot
                let filseOut=this.form.outfoot
                Api.otherFormApi.updateBabyFootRecord(params,filesIn,filseOut).then( res => {
                    if(res.errcode==200){
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                child_id:this.$route.query.child_id,
                                tabVal: this.$route.query.tabVal,
                                name : 'christmas_form_eight',
                            }
                        })
                    }
                    // this.$router.push({
                    //     path:'christmas_form_six_detail', 
                    //     query:{
                    //         id:this.$route.query.id,
                    //         tabVal: this.$route.query.tabVal,
                    //     }
                    // })
                })
            },
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        tabVal: this.$route.query.tabVal,
                        id: this.$route.query.id
                    }
                })
            },
            //入会图片上传
            fileInImage(e){
                console.info(e.target.files)
                var file = e.target.files[0];
                var that=this;
                lrz(file)
                .then(function (rst) {
                    // 处理成功会执行
                    if(that.form.infoot.length == 6){
                        that.$vux.toast.show({
                            type: 'cancel',
                            text: '最多上传6张图片',
                        })
                        return
                    }
                    rst.id=that.n++
                    console.info("rst",rst)
                    that.form.infoot.push(rst)
                    console.info(that.form.infoot)
                })
                .catch(function (err) {
                    console.info(err)
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '网络错误',
                    })
                    // 处理失败会执行
                })
            },
            //入会删除图片
            delInImg(file){
                if(this.n==0){
                    this.n=0
                }else{
                    this.n--
                }
                console.info(file)
                for(var i=0;i<this.form.infoot.length;i++){
                    console.info(this.form.infoot[i].id)
                    if(file.id==this.form.infoot[i].id){
                        this.form.infoot.splice(i,1)
                    }
                }
               
            },
            //出会图片上传
            fileOutImage(e){
                console.info(e.target.files)
                var file = e.target.files[0];
                var that=this;
                lrz(file)
                .then(function (rst) {
                    // 处理成功会执行
                    if(that.form.outfoot.length == 6){
                        that.$vux.toast.show({
                            type: 'cancel',
                            text: '最多上传6张图片',
                        })
                        return
                    }
                    rst.id=that.m++
                    console.info("rst",rst)
                    that.form.outfoot.push(rst)
                    console.info(that.form.outfoot)
                })
                .catch(function (err) {
                    console.info(err)
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '网络错误',
                    })
                    // 处理失败会执行
                })
            },
            //出会删除图片
            delOutImg(file){
                if(this.m==0){
                    this.m=0
                }else{
                    this.m--
                }
                console.info(file)
                for(var i=0;i<this.form.outfoot.length;i++){
                    console.info(this.form.outfoot[i].id)
                    if(file.id==this.form.outfoot[i].id){
                        this.form.outfoot.splice(i,1)
                    }
                }
               
            }
        },
        created(){
           
        }
    }



// WEBPACK FOOTER //
// ./src/components/christmas_form_eight.vue